import useMessage from "../Hooks/useMessage";
import {MENSAJE_ERROR_SERVIDOR_USUARIO}  from "../Utils";
export default function useExceptionHandler(e) {
    const { Warning, Error, NoConnection } = useMessage();
    const isRequestAborted = (error) => {
        console.dev(error);
        if (error.name !== "AbortError") {
            return true;
        }
    };
    const handleException = (error) => {
        // console.dev(`%c ${error.message}!`, "background-color: #f16101");
        if (error.abortRequest) {
            //no hacer nada por ahora
        } else {
            let message = error.Mensaje
            let errorMessage = MENSAJE_ERROR_SERVIDOR_USUARIO
            if (error.Tipo === "Warning") {
                Warning({ message });
            } else {
                Error({ message:errorMessage });
            }
        }
    };
    return { handleException, isRequestAborted };
}
